import { Component, Input, HostBinding } from '@angular/core';

/**
 *
 * Reveal card example:
 * @stacked-example(My example, reveal-card/reveal-card-showcase.component)
 *
 * As a content Reveal card accepts two instances of `el-card` - for front and back sides.
 *
 * Basic reveal card configuration:
 *
 * ```html
 * <el-reveal-card>
 *   <el-card-front>
 *     <el-card>
 *       <el-card-body>
 *         Front
 *       </el-card-body>
 *     </el-card>
 *   </el-card-front>
 *   <el-card-back>
 *     <el-card>
 *       <el-card-body>
 *         Back
 *       </el-card-body>
 *     </el-card>
 *   </el-card-back>
 * </el-reveal-card>
 * ```
 *
 * ### Installation
 *
 * Import `ElCardModule` to your feature module.
 * ```ts
 * @NgModule({
 *   imports: [
 *   	// ...
 *     ElCardModule,
 *   ],
 * })
 * export class PageModule { }
 * ```
 * ### Usage
 *
 * Reveal Card with header and footer:
 * @stacked-example(With Header & Footer, reveal-card/reveal-card-full.component)
 *
 * Colored reveal-cards could be simply configured by providing a `status` property:
 * @stacked-example(Colored Card, reveal-card/reveal-card-colors.component)
 *
 * It is also possible to assign an `accent` property for a slight card highlight
 * as well as combine it with `status`:
 * @stacked-example(Accent Card, reveal-card/reveal-card-accents.component)
 *
 * @additional-example(Multiple Sizes, reveal-card/reveal-card-sizes.component)
 */
@Component({
  selector: 'el-reveal-card',
  styleUrls: ['./reveal-card.component.css'],
  template: `
    <ng-content select="el-card-front"></ng-content>
    <div class="second-card-container">
      <ng-content select="el-card-back"></ng-content>
    </div>
    <a *ngIf="showToggleButton" class="reveal-button" (click)="toggle()">
      <el-icon icon="chevron-down-outline" pack="endlessjs-essentials" aria-hidden="true"></el-icon>
    </a>
  `,
})
export class ElRevealCardComponent {
  /**
   * Reveal state
   * @type boolean
   */
  @Input()
  @HostBinding('class.revealed')
  revealed: boolean = false;

  /**
   * Show/hide toggle button to be able to control toggle from your code
   * @type {boolean}
   */
  @Input() showToggleButton = true;

  toggle() {
    this.revealed = !this.revealed;
  }
}
